import React from "react";
import "../../scss/dashboard/dashPlantillas.css";
import { NavLink, Route, Switch, useRouteMatch, Redirect } from "react-router-dom";
import Publicadas from "./Publicadas";
import EnAprobacion from "./EnAprobacion";
import { ProfileSchema } from "../ProfileForm";
function DashMisPlantillas() {
  const { path } = useRouteMatch();
  return (
    <section className="DashMisPlantillas">
      <div className="DashMisPlantillas__menu">
        <NavLink
          to="/lawyers/templates/published"
          exact={true}
          className="misPlantillas__menuButton"
          activeClassName="misPlantillas__menuButton--active"
        >
          <span className="plantillas__menu-text">Publicadas</span>
        </NavLink>
        <NavLink
          to="/lawyers/templates/in-review"
          className="misPlantillas__menuButton"
          activeClassName="misPlantillas__menuButton--active"
        >
          <span className="plantillas__menu-text">En Aprobación</span>
        </NavLink>
      </div>
      <Switch>
        <Route path={`${path}/published`}>
          <Publicadas />
        </Route>
        <Route path={`${path}/in-review`}>
          <EnAprobacion />
        </Route>
        <Redirect path={path} to={`${path}/published`} />
      </Switch>

    </section>
  );
}

export default DashMisPlantillas;
